// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfMinute as fn } from "../startOfMinute.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfMinute = convertToFP(fn, 1);

// Fallback for modularized imports:
export default startOfMinute;
